import React, { useContext,useEffect } from "react";
import NftContainer from "../NftContainer/NftContainer";
import Form from "../Form/Form";

import BaseLayout from "../BaseLayout/index";

//Material Components
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import FooterCard from "../Footer/Footer";

//Context
import { useWallet } from "../../context/walletProvider";
import { handleApprove, fetchWhitelisted } from '../web3Wrapper'

const useStyles = makeStyles(({ breakpoints, spacing }, theme) => ({
  root: {
    flexGrow: 1,
  },
}));

function Home() {
  const classes = useStyles();
  const wallet = useWallet();

  console.log(wallet)
  useEffect(()=>{
    async function update(){
      if(wallet.status == "connected"){
        const tokens = await fetchWhitelisted(wallet.account)
        console.log(tokens)
        wallet.updateUserTokens(tokens)
      }
    }
    update()
  },[wallet])
    return (
      <BaseLayout className={classes.root}>
        <div className='home-container'>
          <Grid container style={{ height: "100vh"}}>
            <Grid item xs={8}>
              <NftContainer
              handleApprove={handleApprove}
              />
            </Grid>
            <Grid item xs={4}>
              <Form />
            </Grid>
          </Grid>
          <FooterCard />
        </div>
      </BaseLayout>
    );
}

export default Home;
